import React from 'react'
import TransformEntriesToObservableMaps from 'support/collections/TransformEntriesToObservableMaps'
import {
  ForEachModel,
  ValueToCollection,
  WhenCollectionIsNotEmpty,
  WhenLoaded,
  WhenNotLoading
} from '@morningtrain/react-resources'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import AvailableSupplierItems from 'widgets/inventory/AvailableSupplierItems'
import WhenOrderCategoryItemsHasNorm from 'pages/app/inventory/order/partials/WhenOrderCategoryItemsHasNorm'
import WhenOrderCategoryItemsHasSearchedFor
  from "pages/app/inventory/order/partials/WhenOrderCategoryItemsHasSearchedFor";

export default function ForEachOrderItemCategory ({
  children,
  fields = null,
  excludeWithoutNorm = false
}) {
  const inner = (
    <UI.Card>
      <UI.CardHeader withMargin={false} className='-mb-10'>
        <UI.SecondaryHeading>
          <Displays.Text name='key' />
        </UI.SecondaryHeading>
      </UI.CardHeader>
      {children}
    </UI.Card>
  )

  return (
    <AvailableSupplierItems>
      <TransformEntriesToObservableMaps path='collection' />
      <WhenLoaded>
        <WhenNotLoading>
          <UI.CardGroup>
            <ForEachModel>
              <ValueToCollection name='collection'>
                <WhenCollectionIsNotEmpty>
                  {fields}
                  {excludeWithoutNorm
                    ? (
                      <WhenOrderCategoryItemsHasNorm>
                        <WhenOrderCategoryItemsHasSearchedFor>
                          {inner}
                        </WhenOrderCategoryItemsHasSearchedFor>
                      </WhenOrderCategoryItemsHasNorm>
                      )
                    : (
                        <WhenOrderCategoryItemsHasSearchedFor>
                          {inner}
                        </WhenOrderCategoryItemsHasSearchedFor>
                      )
                  }
                </WhenCollectionIsNotEmpty>
              </ValueToCollection>
            </ForEachModel>
          </UI.CardGroup>
        </WhenNotLoading>
      </WhenLoaded>
    </AvailableSupplierItems>
  )
}
